import type { client } from "@/utils/orpc.client";

type ListsItemsData = Awaited<ReturnType<typeof client.lists.getListsItems>>;

export function buildListMembershipIndexes(lists: ListsItemsData["lists"]) {
  const releaseToListIds = new Map<string, Set<string>>();
  const workToListIds = new Map<string, Set<string>>();

  for (const list of lists) {
    for (const releaseId of list.releaseIds) {
      const listIds = releaseToListIds.get(releaseId) ?? new Set<string>();
      listIds.add(list.id);
      releaseToListIds.set(releaseId, listIds);
    }
    for (const workId of list.workIds) {
      const listIds = workToListIds.get(workId) ?? new Set<string>();
      listIds.add(list.id);
      workToListIds.set(workId, listIds);
    }
  }
  return { releaseToListIds, workToListIds };
}
